import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
// icons
import Quotation from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/QuotationMarkDoubleCurved';
// images
import imageWebp from './images/testimonials-bg.webp';

export const BlockquoteStyled = styled.blockquote`
  padding: 0;
  margin: 0;
`;

export const FigureStyled = styled.figure`
  padding: 0;
  margin: 0;
`;

export const QuotationStyled = styled(Quotation)`
  ${({ theme }) => {
    return css`
      color: ${theme.colors.brand.pcg.gold2};
      margin-bottom: ${rem(20)};
    `;
  }
}`;

export const SectionContainerStyled = styled(SectionContainer)`
  margin: 0;
  width: 100%;
  background-image: url(${imageWebp.toString()});
  background-size: cover;
  background-position: bottom;
`;

